import React from 'react';
import classNames from 'classnames';
import Heading from "@scentregroup/ui/components/heading";
import Paragraph from "@scentregroup/ui/components/paragraph";
import ResponsiveImage from '../../responsive-image';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const JengaItem = _ref => {
  let {
    className,
    image,
    title,
    body
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(className, style['jenga-item']),
    "data-id": "jenga-item_index_JengaItem_div",
    children: [image ? /*#__PURE__*/_jsx(ResponsiveImage, {
      desktopImageUrl: image,
      mobileImageUrl: image,
      desktopRatio: "square",
      mobileRatio: "square",
      alt: "",
      "data-id": "jenga-item_index_JengaItem_ResponsiveImage"
    }) : '', title ? /*#__PURE__*/_jsx(Heading, {
      type: "extrasmall",
      className: classNames(style.title),
      "data-id": "jenga-item_index_JengaItem_Heading",
      children: title
    }) : '', body ? /*#__PURE__*/_jsx(Paragraph, {
      type: "small",
      className: classNames(style.body),
      "data-id": "jenga-item_index_JengaItem_Paragraph",
      children: body
    }) : '']
  });
};

export default JengaItem;